<template>
  <div style="width: 1000px; background-color: blue">
    <div style="width: 700px; float: left">
      <div class="psychology">
        <div class="item">
          立项时间:
          <el-select v-model="model.SubmitYear" class="m-2" placeholder="请选择年份" @change="Serarch">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
        <!-- <div class="item">
          项目类别
          <el-select v-model="model.EduApplyType" class="m-2" placeholder="请选择项目类别">
            <el-option v-for="item in eduChangeApplyType" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div> -->
        <!-- <div class="item">查阅通知</div>
        <div class="item-text" v-if="model.SubmitYear === '2022'">
          <el-link
            href="https://hspublicfileoss.oss-cn-beijing.aliyuncs.com//Important/SignUP/admin/EducationReform/关于提交2022年度教改项目结题报告的通知.docx"
            type="primary"
            target="_blank"
            >关于提交2022年度教改项目结题报告的通知</el-link
          >
        </div>
        <div class="item-text" v-if="model.SubmitYear === '2023'">
          <el-link
            href="https://hspublicfileoss.oss-cn-beijing.aliyuncs.com/Important/SignUP/admin/EducationReform/%E6%8F%90%E4%BA%A4%E7%BB%93%E9%A2%98%E6%8A%A5%E5%91%8A%E5%92%8C%E4%B8%AD%E6%9C%9F%E6%8A%A5%E5%91%8A%E9%80%9A%E7%9F%A5.pdf"
            type="primary"
            target="_blank"
            >提交结题报告和中期报告通知</el-link
          >
        </div> -->
        <div v-for="item in model.Leaders" :key="item">
          <div class="item">
            负责人{{ item.Index }}:
            <el-input v-model="item.Leader" class="m-2 w-2" style="width: 235px" placeholder="" />
            <span @click="removeLeader(item)" style="margin-left: 2px; color: blue; cursor: pointer">删除</span>
          </div>

          <div class="item">提交报告:</div>
          <div class="upload-media-prove upload">
            <el-upload class="upload-demo" drag action="#" :auto-upload="false" :file-list="item.fileList" multiple
              :on-change="(file) => {
                handleChange(file, item);
              }
                " :on-remove="(file) => {
                  handleRemove(file, item);
                }
                  ">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">拖到此处或 <em>点击上传</em></div>
              <template #file="{ file }">
                <a class="el-upload-a cursor el-upload-list__item-name" style="text-decoration: none"
                  :href="getURL(file.fileSignPath)" target="_blank">
                  <i class="el-icon-document"></i>
                  {{ file.name }}
                </a>
                <label class="el-upload-list__item-status-label">
                  <i class="el-icon-upload-success el-icon-circle-check"></i>
                </label>
                <i class="el-icon-close" @click="handleRemove(file, item)"></i>
              </template>
            </el-upload>
          </div>
          <el-button @click="addLeader(item)">添加负责人</el-button>
        </div>
        <div class="btn" style="margin: 40px 0 0 0px">
          <!-- <div class="btn-draft cursor" @click="Submit('0')">
                    <span>保存为草稿</span>
                </div> -->
          <div class="btn-submit cursor" @click="Submit()">
            <span>提交</span>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 300px; float: left" v-show="isShow">
      <span>状态提醒</span>
      <p v-for="item in fromList" :key="item.Id">
        <span>负责人：{{ item.Leader }}</span>
        <span style="color: green; cursor: pointer">已提交</span>
        <!-- <span
          @click="GetSing(item.SubmitYear, item.Leader)"
          style="color: green; cursor: pointer"
          >已提交</span
        > -->
      </p>
      <!-- <p><span>负责人：张三</span> <span>已提交</span></p> -->
    </div>
  </div>
</template>
<script>
import { ElMessage } from "element-plus";
import {
  SaveEducationReformSubmit,
  GetUserEducationSubmitReform,
  // GetUserEducationSubmitReformList
} from "../../http/psychologyTemp";
import router from "../../router/index";
import { _local } from "../../utils/storage";
import { reactive, ref } from "vue";
import { multipartUpload } from "../../utils/ali-oss";
import { getURL } from "../../utils/utils";
import { eduChangeApplyType } from "../../utils/constSetting";
export default {
  mounted() {
    this.GetEducationSubmitReformList();
  },
  data() {
    const submitYear = ref(new Date().getFullYear());

    let options = []
    for (let i = 2022; i <= new Date().getFullYear(); i++) {
      options.push({
        value: i,
        label: i
      })
    }
    let matchId = JSON.parse(decodeURIComponent(router.currentRoute.value.query.MatchId));
    let forumId = JSON.parse(decodeURIComponent(router.currentRoute.value.query.ForumId));

    const user = _local.get("user");

    const request = reactive({
      userId: user.Id,
      submitYear: "",
      Leader: "",
      MatchId: matchId,
      ForumId: forumId,
    });
    let model = reactive({
      Id: "",
      MatchId: matchId,
      ForumId: forumId,
      SubmitYear: submitYear.value,
      UserId: user.Id,
      // EduApplyType: undefined,
      Leaders: [
        {
          Index: 1,
          Leader: "",
          FileName: "",
          FilePath: "",
          fileList: [],
        },
      ],
    });
    let data = reactive({
      Model: {
        MatchId: matchId,
        ForumId: forumId,
        UserId: user.Id,
        Leader: "",
        ExcelName: "",
        ExcelPath: "",
        WorkNo: "",
        SubmitYear: submitYear.value,
        Id: "",
        Status: 0,
      },
    });
    return {
      submitYear,
      options,
      matchId,
      forumId,
      user,
      data,
      getURL,
      fileList: [],
      request,
      fromList: [],
      isShow: false,
      model,
      eduChangeApplyType,
    };
  },
  methods: {
    GetEducationSubmitReformList() {
      this.request.submitYear = this.model.SubmitYear;
      this.Serarch();
      // GetUserEducationSubmitReformList(this.request)
      //   .then((res) => {
      //     if (res.IsSuccess) {
      //       if (res.Models.length > 0) {
      //         this.fromList = res.Models
      //         this.isShow = true
      //       }
      //     }
      //   })
      //   .catch(() => {
      //     ElMessage.error('异常')
      //   })
    },

    async upload(file, item) {
      let path = await multipartUpload(file);
      if (path != "" && path != null) {
        item.fileList.push({
          name: file.name,
          url: path,
        });
        file.url = path;
      }
    },
    handleChange(file, item) {
      if (item.fileList.length >= 1) {
        ElMessage({
          message: "最多只能上传一个文件",
          type: "warning",
        });
        item.fileList = item.fileList.filter((item) => {
          return item.url != file.url;
        });
        return false;
      }
      this.upload(file, item);
    },
    handleRemove(file, item) {
      item.fileList = item.fileList.filter((item) => {
        return item.url != file.url;
      });
    },
    ChangeYear() {
      ElMessage.error("异常");
    },
    GetSing(SubmitYear, Leader) {
      this.data.Model.SubmitYear = SubmitYear;
      this.data.Model.Leader = Leader;
      this.Serarch();
    },
    Serarch() {
      this.request.submitYear = this.model.SubmitYear;
      GetUserEducationSubmitReform(this.request)
        .then((res) => {
          if (res.IsSuccess) {
            if (res.Models != null) {
              var models = res.Models;
              for (var i in models.Leaders) {
                models.Leaders[i].fileList = [
                  {
                    name: models.Leaders[i].FileName,
                    url: models.Leaders[i].FilePath,
                    fileSignPath: models.Leaders[i].FileSignPath,
                  },
                ];
              }
              // if (models.EduApplyType === 0) {
              //   models.EduApplyType = undefined;
              // }
              this.model = models;
            } else {
              this.model = {
                Id: "",
                MatchId: this.matchId,
                ForumId: this.forumId,
                SubmitYear: this.model.SubmitYear,
                UserId: this.user.Id,
                // EduApplyType: undefined,
                Leaders: [
                  {
                    Index: 1,
                    Leader: "",
                    FileName: "",
                    FilePath: "",
                    fileList: [],
                  },
                ],
              };
            }
          } else {
            ElMessage.error(res.ErrorMessage);
          }
        })
        .catch((err) => {
          console.log(err);
          ElMessage.error("异常");
        });
    },
    Submit() {
      // if (!this.model.EduApplyType || this.model.EduApplyType === 0) {
      //   ElMessage.error("请选择项目类别");
      //   return;
      // }
      for (var i in this.model.Leaders) {
        if (this.model.Leaders[i].Leader == null || this.model.Leaders[i].Leader == "") {
          ElMessage.error("请填写负责人" + parseInt(i) + 1);
          return;
        }
        if (
          this.model.Leaders[i].fileList == null ||
          this.model.Leaders[i].fileList.length <= 0
        ) {
          ElMessage.error("请上传负责人" + parseInt(i) + 1 + "提交报告");
          return;
        }
        this.model.Leaders[i].FileName = this.model.Leaders[i].fileList[0].name;
        this.model.Leaders[i].FilePath = this.model.Leaders[i].fileList[0].url;
      }
      SaveEducationReformSubmit({ saveModel: this.model })
        .then((res) => {
          if (res.IsSuccess) {
            ElMessage({
              message: res.SuccessMessage,
              type: "success",
            });
            this.GetEducationSubmitReformList();
          } else {
            ElMessage.error(res.ErrorMessage);
          }
        })
        .catch(() => {
          ElMessage.error("异常");
        })
        .finally(() => {
          this.data.Model.Status = 1;
        });
    },
    addLeader() {
      this.model.Leaders.push({
        Index: this.model.Leaders.length + 1,
        Leader: "",
        FileName: "",
        FilePath: "",
        fileList: [],
      });
    },
    removeLeader(item) {
      if (this.model.Leaders.length <= 1) {
        return;
      }
      var index = this.model.Leaders.indexOf(item);
      this.model.Leaders.splice(index, 1);
      var leaders = [];
      for (var i in this.model.Leaders) {
        this.model.Leaders[i].Index = parseInt(i) + 1;
        leaders.push(this.model.Leaders[i]);
      }
      this.model.Leaders = leaders;
    },
  },
};
</script>

<style lang="scss" scoped>
.psychology {
  width: 360px;
}

.circle {
  margin-top: 20px;
}

.isShowTab {
  width: 100%;
  margin-top: 20px;
}

.circle {
  margin-top: 20px;
}

.text-tab {
  margin-left: 30px;
  border-bottom: 1px solid black;
  font-family: MicrosoftYaHei;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: normal;
  text-align: left;
  color: #666;
  cursor: pointer;
}

.item {
  margin-top: 30px;
}

.item-text {
  margin-top: 20px;
}

.upload-tab {
  display: inline;
  float: right;
  width: 100px;

  >button {
    color: red;
    border: solid 1px red;
  }
}

.table {
  margin-top: 20px;
}

.upload {
  margin-top: 20px;
}

.save {
  width: 100%;
  height: 32px;
  text-align: right;
}

.tab-save {
  font-family: MicrosoftYaHei;
  font-size: 13px;
  line-height: 0.92;
  letter-spacing: 0.13px;
  text-align: center;
  color: #a31f34;
  width: 85px;
  height: 32px;
  border: solid 1px #a31f34;
  background-color: var(--h-0-s-0-l-100);
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #a31f34;
  margin: 0 auto;
}

.download {
  width: 20%;
  text-align: right;
}

.btn {
  width: 100%;
  text-align: center;
  margin-top: 30px;
  display: flex;
  align-items: left;
  justify-content: left;
  color: rgba(255, 255, 255, 0.8);
  line-height: 44px;
  margin-bottom: 20px;
}

.btn-draft {
  min-width: 150px;
  width: 200px;
  height: 44px;
  flex-grow: 0;
  background-color: #a31f34;
  margin-right: 40px;

  >span {
    flex-grow: 0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 0.28px;
    text-align: center;
    color: var(--h-0-s-0-l-100);
  }
}

.btn-submit {
  float: right;
  text-align: center;
  min-width: 150px;
  width: 200px;
  height: 44px;
  flex-grow: 0;
  background-color: #a31f34;

  >span {
    flex-grow: 0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 0.28px;
    text-align: center;
    color: var(--h-0-s-0-l-100);
  }
}

.el-upload-a {
  text-decoration: none;
}

.steps {
  width: 300px;
  max-width: 30%;
  float: right;
  position: absolute;
  top: -50px;
  left: 420px;
}

.cursor {
  cursor: pointer;
}
</style>
